<template>
  <div class="mod" v-if="course && currentModule">

    <div class="mod__arr mod__arr--left"
         v-if="prevModule"
         :class="getStatusPrewMaterialItem"
         @click="onStep(prewActiveMaterial, 'prew')">
      <span></span>
    </div>

    <div class="mod__main">
      <span>{{ currentModule.name }}</span>
      <b>{{ currentModule.title }}</b>
    </div>

    <div class="mod__arr mod__arr--right"
         v-if="nextModule"
         :class="getStatusNextMaterialItem"
         @click="onStep(nextActiveMaterial, 'next')">
      <span></span>

      <i class="mod__label">{{ $t('moduleEmpty') }}</i>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';

export default {
  name: 'sidebar-index',
  props: ['activeIndex', 'modules'],

  computed: {
    ...mapGetters({
      course: 'courses/currentItem'
    }),

    selectedIndex() {
      return this.activeIndex - 1
    },

    selectedModule() {
      return this.modules[this.selectedIndex];
    },

    currentIndexes() {
      let course = this.course;
      let currentItem = this.selectedModule;
      let currentModuleIndex,
          currentMaterialIndex;

      course.modules.data.forEach((module, moduleIndex) => {
        module.materials.data.forEach((material, materialIndex) => {
          // if (currentItem.slug === material.slug){
          if (currentItem.id === material.id && currentItem.slug === material.slug) {
            currentModuleIndex = moduleIndex;
            currentMaterialIndex = materialIndex;
          }

        })
      });

      return {
        currentModuleIndex: currentModuleIndex,
        currentMaterialIndex: currentMaterialIndex
      }
    },

    currentModule() {
      return this.course.modules.data[this.currentIndexes.currentModuleIndex];
    },

    nextModule() {
      return this.course.modules.data[this.currentIndexes.currentModuleIndex + 1];
    },

    prevModule() {
      return this.course.modules.data[this.currentIndexes.currentModuleIndex - 1];
    },

    prewActiveMaterial() {
      let list = this.prevModule ? this.prevModule.lessons.data : [],
          activeMaterial = null;

      if (!list.length) return null;

      for (let i = 0; i < list.length; i++) {
        let item = list[i];
        let typeMaterial = item.material === 'lesson' ? 'userLesson' : 'userHomeWork';
        let status = item[typeMaterial].data.hasOwnProperty('id') ? item[typeMaterial].data.status : 'new';

        if (status !== 'failed' && status !== 'locked') {
          activeMaterial = item;
          break;
        }
      }

      return activeMaterial;
    },

    nextActiveMaterial() {
      let list = this.nextModule ? this.nextModule.lessons.data : [],
          activeMaterial = null;

      if (!list.length) return null;

      for (let i = 0; i < list.length; i++) {
        let item = list[i];
        let typeMaterial = item.material === 'lesson' ? 'userLesson' : 'userHomeWork';
        let status = item[typeMaterial].data.hasOwnProperty('id') ? item[typeMaterial].data.status : 'new';

        if (status !== 'failed' && status !== 'locked' && status !== 'expired') {
          activeMaterial = item;
          break;
        }
      }

      return activeMaterial;
    },

    getStatusPrewMaterialItem() {
      const item = this.prewActiveMaterial;
      if (!item) {
        return 'locked'
      }
      const typeMaterial = item.material === 'lesson' ? 'userLesson' : 'userHomeWork'
      return item[typeMaterial].data.hasOwnProperty('id') ? item[typeMaterial].data.status : 'new'
    },

    getStatusNextMaterialItem() {
      const item = this.nextActiveMaterial;
      if (!item) {
        return 'locked'
      }
      const typeMaterial = item.material === 'lesson' ? 'userLesson' : 'userHomeWork'
      return item[typeMaterial].data.hasOwnProperty('id') ? item[typeMaterial].data.status : 'new'
    }
  },

  methods: {
    onStep(material, type) {
      let nextMaterial = material;
      if (!nextMaterial) return;

      let module = type === 'next' ? this.nextModule : this.prevModule;

      try {
        if (nextMaterial.material === 'lesson') {
          this.$router.push({
            name: 'courses-lesson-detail',
            params: {item: this.$route.params.item, moduleSlug: module.slug, lessonSlug: nextMaterial.slug}
          })
        } else {
          this.$router.push({
            name: 'home-work-rules',
            params: {item: this.$route.params.item, moduleSlug: module.slug, testId: nextMaterial.slug}
          })
        }
      } catch (e) {
        console.log('');
      }
    }
  }
};
</script>

<style scoped lang=scss>
.mod {
  padding-top: 30px;
  margin-bottom: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;

  &__main {
    text-align: center;
    margin: 0 30px;

    b {
      display: block;
    }

    span {
      display: block;
      margin-bottom: 10px;
    }
  }

  &__arr {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    &:hover {
      border-right-color: green;
      border-left-color: green;
    }

    &.locked {
      opacity: 0.5;

      &:hover {
        .mod__label {
          opacity: 1;
          visibility: visible;
        }
      }

    }

    span {
      display: block;
      width: 0;
      height: 0;
    }

    &--left {
      span {
        border-top: 5px solid transparent;
        border-right: 10px solid #000;
        border-bottom: 5px solid transparent;
      }

    }

    &--right {
      span {
        border-top: 5px solid transparent;
        border-left: 10px solid #000;
        border-bottom: 5px solid transparent;
      }
    }
  }

  &__label {
    position: absolute;
    font-size: 12px;
    width: 150px;
    top: 110%;
    text-align: center;
    left: 50%;
    transform: translateX(-50%);
    opacity: 0;
    visibility: hidden;
  }
}
</style>
